import { cellRenderParseData } from '../../../utils/functions';

const columnDataGraif = [
  {
    dataField: 'dateProcessingStart',
    caption: 'Дата производства',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'commonNumber',
    caption: 'Общий номер',
    dataType: 'string'
  },
  {
    dataField: 'sizes',
    caption: 'Размеры',
    dataType: 'string'
  }

];

export default columnDataGraif;
